module.exports = __webpack_public_path__ + "img/menu_bottom_3.6dac8f67.svg";